import { render, staticRenderFns } from "./liveEmbedVideo.vue?vue&type=template&id=a127c3ca"
import script from "./liveEmbedVideo.vue?vue&type=script&lang=js"
export * from "./liveEmbedVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports